import React from 'react';
import ReactDOM from 'react-dom';

interface Button {
  onClose: () => void;
  buttonName: string;
}

interface AlertModalProps {
  isOpen: boolean;
  closeBtn: Button;
  confirmBtn?: Button;
  children: React.ReactNode;
}

const AlertModal: React.FC<AlertModalProps> = ({ isOpen, closeBtn, confirmBtn, children }) => {
  const handleClickOutside = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className="modal_wrapper" onClick={(e) => handleClickOutside(e)}>
      <div className="black_bg"></div>
      <div className="alert_modal" onClick={(e) => e.stopPropagation()}>
        <p className="modal_txt">{children}</p>
        <div className="button">
          {confirmBtn && (
            <button style={{ marginRight: '10px' }} onClick={confirmBtn.onClose}>
              {confirmBtn.buttonName}
            </button>
          )}
          <button onClick={closeBtn.onClose}>{closeBtn.buttonName}</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AlertModal;
